import React from 'react';
import { CheckCircle, Home } from 'lucide-react';

interface SuccessPageProps {
  onBackToHome: () => void;
}

export function SuccessPage({ onBackToHome }: SuccessPageProps) {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="bg-gray-900 rounded-2xl p-8 max-w-md w-full shadow-2xl border border-green-500/20 text-center">
        <div className="mb-6">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-green-500 mb-2">Payment Successful!</h1>
          <p className="text-gray-300">
            Thank you for your purchase. Your payment has been processed successfully.
          </p>
        </div>

        <div className="bg-gray-800/50 p-4 rounded-lg mb-6">
          <p className="text-gray-400 text-sm">
            You should receive a confirmation email shortly with your purchase details.
          </p>
        </div>

        <button
          onClick={onBackToHome}
          className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white py-3 px-6 rounded-lg font-bold hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
        >
          <div className="flex items-center justify-center gap-2">
            <Home className="w-5 h-5" />
            Back to Game
          </div>
        </button>
      </div>
    </div>
  );
}